export class FilterEmployee {
    ne!: string;
    n!: string;
    ps!: string;
    ms!: string;
    ac!: number;
}